import React from 'react';
import { getWeatherIconClass, getWindIconClass } from '../utils/weatherIconMapper';
import TodayForecast from './TodayForecast';
import 'weather-icons/css/weather-icons.min.css';

const WeatherCurrent = ({ weather, todayForecast }) => {
  const weatherIconClass = getWeatherIconClass(weather.condition, weather.isDay);
  const windIconClass = getWindIconClass(weather.windSpeed, weather.windDirection);

  return (
    <div className="current-weather">
        <div className="current-weather-container">
            <div className="current-weather-top">
                <i className={`wi ${weatherIconClass} weather-icon large-icon`}></i>
                <div className="temp-condition">
                    <div className="right-now-label">RIGHT NOW</div>
                    <div className="temperature">
                    {weather.temperature}<span>°</span>
                    </div>
                    <div className="condition">{weather.condition}</div>
                </div>
            </div>
            <div className="current-weather-bottom">
                <div className="weather-details">
                    <div className="detail-item">
                        <span className="detail-label">Humidity</span>
                        <span className="detail-value"><i className="wi wi-humidity"></i> {weather.humidity}%</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">UV Index</span>
                      <span className="detail-value"><i className="wi wi-thermometer-exterior"></i> {weather.uvIndex || 'N/A'}</span>
                    </div>
                    <div className="detail-item">
                        <span className="detail-label">Feels Like</span>
                        <span className="detail-value"><i className="wi wi-thermometer"></i> {weather.feelsLike}°</span>
                    </div>
                    <div className="detail-item">
                        <span className="detail-label">Sunrise</span>
                        <span className="detail-value"><i className="wi wi-sunrise"></i> {weather.sunrise}</span>
                    </div>
                    <div className="detail-item">
                        <span className="detail-label">Heat Index</span>
                        <span className="detail-value"><i className="wi wi-thermometer"></i> {weather.heatIndex || weather.temperature}°</span>
                    </div>
                    <div className="detail-item">
                        <span className="detail-label">Sunset</span>
                        <span className="detail-value"><i className="wi wi-sunset"></i> {weather.sunset}</span>
                    </div>
                     <div className="detail-item">
                        <span className="detail-label">Wind</span>
                        <span className="detail-value"><i className={windIconClass}></i> {weather.wind}</span>
                    </div>
                     <div className="detail-item">
                        <span className="detail-label">Dew Point</span>
                        <span className="detail-value"><i className="wi wi-raindrop"></i> {weather.dewPoint}°</span>
                    </div>
                    <div className="detail-item">
                        <span className="detail-label">Wind Chill</span>
                        <span className="detail-value"><i className="wi wi-strong-wind"></i> {weather.windChill}°</span>
                    </div>
                    <div className="detail-item">
                        <span className="detail-label">Visibility</span>
                        <span className="detail-value"><i className="wi wi-fog"></i> {weather.visibility} mi</span>
                    </div>
                </div>
            </div>
        </div>
        {todayForecast && <TodayForecast forecast={todayForecast} />}
    </div>
  );
};

export default WeatherCurrent; 